import React from 'react';
import { Badge, Bubble, Icon, Progress } from 'tea-component';
import { useHistory, useIntl } from 'umi';
import Image from 'rc-image';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import Loading from '@/pages/intelligence/components/Loading';
import TipOne from '@/pages/intelligence/assets/svg/tipicon/tip-one.svg';
import TipTwo from '@/pages/intelligence/assets/svg/tipicon/tip-two.svg';
import TipThree from '@/pages/intelligence/assets/svg/tipicon/tip-three.svg';
import SvgIcon from '@/pages/home/components/SvgIcon';
import defaultKol from '@/pages/intelligence/assets/svg/tipicon/kol-default.svg';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import './index.scss';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import loadingSvg from '@/pages/intelligence/assets/svg/loading.svg';


const ModuleCard = (porps: any) => {
  const { data, loading, hoverBubbleText } = porps;

  const { isOperate, filterExtend, setFilterExtend } = useFilterExtend(
    {},
  );
  const history = useHistory();
  const dataList = data.list.length > 10 ? data.list.splice(10) : data.list;
  const handleOnClickGoDetail = (type: string) => {
    const platfrom = {
      'Key Metrics': 'twitch',
      'YouTube Channels': 'ytg',
      'Facebook Channels': 'facebook',
    }[type as string];
    if (isOperate) {
      setFilterExtend(filterExtend)
    }
    history.push({
      pathname: `/intelligence/streaming/influencer/details/${platfrom}`,
    });
  };
  return (
    <CardSlot
      className="dbi-kol-card"
      isAction
      getDetails={() => handleOnClickGoDetail(data.link)}
      iconList={[]}
      rightDom={
        <div className="dbi-kol-card-subtitle">
          <Badge className='dbi-kol-card-badge' dot /> <span className="dbi-kol-card-badgetext">{hoverBubbleText}</span>
        </div>
      }
      title={
        <>
          <img src={data.svg} className="kol-card-img" />
          {data.title}
        </>
      }
    >
      {loading ? (
        <div style={{ height: '670px' }}>
          <Loading></Loading>
        </div>
      ) : (
        dataList.map((e: any, i: any) => (
          <ContentItem itemData={e} key={i} {...{ hoverBubbleText }} />
        ))
      )}
    </CardSlot>
  );
};

export default ModuleCard;

const ContentItem = (porps: any) => {
  const { itemData, loading = false, hoverBubbleText } = porps;
  const levelImg = [TipOne, TipTwo, TipThree];
  const { formatMessage } = useIntl();
  const hanldeOnClickOpenLink = () => {
    window.open(itemData?.url);
  };
  return (
    <>
      <ARightClickToJump
        href={itemData?.url}
      // style={{ display: 'inline' }}
      >
        <Bubble
          dark
          style={{ width: '320px' }}
          // trigger="click"
          placement="top-end"
          content={
            '' /*
          <div className="dbi-bubble-context">
            <div className="bubble-context-message">
              <img
                onError={(e: any) => {
                  e.target.src = defaultKol;
                }}
                src={itemData.img || defaultKol} className="bubble-context-message-img" />
              <div className="bubble-context-message-title">
                {itemData.title}
              </div>
              {itemData.desc ? (
                <div className="bubble-context-message-desc">
                  {itemData.desc}
                </div>
              ) : null}
            </div>
            <div className="bubble-context-tip">
              <div className="bubble-context-tip-text">
                <div
                  className="bubble-round"
                  style={{ background: '#326FF0' }}
                />
                <span>{hoverBubbleText}</span>
              </div>
              <div className="bubble-context-tip-num">
                <span className="tip-num-value">{itemData.value || '-'}</span>
                <span className="tip-num-text">
                  {`${Math.abs(itemData.ratio) > 9999
                    ? '9999+'
                    : Math.abs(itemData.ratio)
                    }%` || '-'}
                </span>
                <SvgIcon
                  type={
                    !itemData?.ratio.indexOf('-')
                      ? 'arrow-other-down'
                      : 'arrow-other-up'
                  }
                  className="bubble-context-tip-svg"
                />
              </div>
            </div>
          </div>
        */
          }
          className="dbi-kol-bubble"
        >
          <div className="dbi-kol-item" onClick={hanldeOnClickOpenLink}>
            <div className="dbi-kol-item-left">
              <div className="kol-serial-number">
                {itemData.id <= 3 ? (
                  <img src={levelImg[itemData.id - 1]} className="item-tip" />
                ) : (
                  <div className="item-text">{itemData.id}</div>
                )}
              </div>
              <Image
                className="kol-img"
                src={itemData.img || defaultKol}
                placeholder={<img className={'img-loading'} src={loadingSvg} />}
                // placeholder={
                //   <Icon type="loading" style={{ color: '#F2F3F5' }} size="l" />
                // }
                preview={false}
                fallback={defaultKol}
              />
              <div className="dbi-kol-item-center">
                <div className="center-context">
                  <div className="center-context-title">{itemData.title}</div>
                  {/* 因为需要中间分割线 里面的overflow: hidden center-context-line  因为有分割线所以要判断一下 */}
                  {itemData.desc ? <div className="center-context-line" /> : ''}
                  <div className="center-context-desc">
                    {itemData.desc ?? ''}
                  </div>
                </div>
                <Progress
                  className="center-progress"
                  percent={itemData.num}
                  width={6}
                  strokeColor="#326FF0"
                />
              </div>
            </div>

            <div className="dbi-kol-item-right">
              {itemData.num ? (
                <div className="kol-right">
                  <span
                    className={
                      itemData.ratio === '0'
                        ? 'kol-right-grey'
                        : !itemData?.ratio.indexOf('-')
                          ? 'kol-right-red'
                          : 'kol-right-green'
                    }
                  >
                    {Math.abs(itemData.ratio) > 9999
                      ? '9999+'
                      : Math.abs(itemData.ratio)}
                    %
                  </span>
                  {/* 红降 red-down-new  绿升 green-up-new */}
                  {itemData.value == 0 ? (
                    <span className="kol-right-grey">-</span>
                  ) : itemData.ratio === '0' ? (
                    '-'
                  ) : (
                    <SvgIcon
                      type={
                        !itemData?.ratio.indexOf('-')
                          ? 'red-down-new'
                          : 'green-up-new'
                      }
                      className="kol-right-icon"
                    />
                  )}
                </div>
              ) : (
                '-'
              )}
              <div className="kol-right-tip">{`${itemData.value ?? '-'}`}</div>
            </div>
          </div>
        </Bubble>
      </ARightClickToJump>
    </>
  );
};
